// WhatsApp message templates for sales team — opens wa.me/ with prefilled text.
// Each template is a function (lead) => string. Sales picks one from dropdown, then clicks Send.
const fmtCode = (code) => code || "your code";
const fmtDate = (iso) => iso ? new Date(iso).toLocaleDateString("en-IN", { day: "numeric", month: "short" }) : "";
const firstName = (n) => (n || "there").split(" ")[0];

export const WHATSAPP_TEMPLATES = [
  {
    id: "welcome",
    label: "👋 Welcome back",
    build: (l) =>
      `Hi ${firstName(l.name)}! This is AutoHQ Ranigunj. Thanks for visiting our site — we'd love to help you with your ${l.car || "car"}. Reply here anytime!`,
  },
  {
    id: "coupon_reminder",
    label: "🎁 Your coupon is waiting",
    build: (l) =>
      `Hi ${firstName(l.name)}! Just a quick reminder — your AutoHQ coupon ${fmtCode(l.coupon_code)} for ${l.prize || "your prize"} is valid till ${fmtDate(l.coupon_expiry)}. Want us to book your ${l.car || "car"} slot? 🚗`,
  },
  {
    id: "coupon_expiring",
    label: "⏰ Coupon expiring soon",
    build: (l) =>
      `Hi ${firstName(l.name)} — your AutoHQ reward ${fmtCode(l.coupon_code)} (${l.prize || ""}) expires on ${fmtDate(l.coupon_expiry)}. Don't miss out! Reply YES to claim today.`,
  },
  {
    id: "service_reminder",
    label: "🔧 Service due reminder",
    build: (l) =>
      `Hi ${firstName(l.name)} — it's been a while since your ${l.car || "car"} had a check-up. AutoHQ uses 100% genuine parts and we'd love to take care of your ride. Should we book a slot this week?`,
  },
  {
    id: "callback_followup",
    label: "📞 Callback follow-up",
    build: (l) =>
      `Hi ${firstName(l.name)}, this is AutoHQ Ranigunj. We received your callback request for ${l.service_needed || "service"} on your ${l.car || "car"}. Is now a good time to chat?`,
  },
  {
    id: "insurance_followup",
    label: "🛡️ Insurance claim follow-up",
    build: (l) =>
      `Hi ${firstName(l.name)} — our insurance team is ready to assist with your ${l.insurer || ""} claim for the ${l.car || "car"}. We handle the entire process end-to-end (cashless if applicable). When can we call you?`,
  },
  {
    id: "care_plus_pitch",
    label: "✨ Pitch Care+ Package",
    build: (l) =>
      `Hi ${firstName(l.name)}! Since you love AutoHQ, here's something exclusive: our Care+ Package gives you ₹10,000 of car care for just ₹1,249/year — washes, AC, alignment, services & more. Want me to share the details?`,
  },
  {
    id: "festive_offer",
    label: "🎉 Festive offer",
    build: (l) =>
      `Hi ${firstName(l.name)}! Festive special at AutoHQ — free wash + 20% off labour this week only. Book your ${l.car || "car"} slot with us today 🎁`,
  },
  {
    id: "ready_for_pickup",
    label: "✅ Ready for pickup",
    build: (l) =>
      `Hi ${firstName(l.name)} — your ${l.car || "car"} is ready for pickup at AutoHQ Ranigunj. Total bill and invoice will be shared shortly. Thank you for choosing us!`,
  },
];

export const buildWhatsappLink = (phone, message) =>
  `https://wa.me/91${phone}?text=${encodeURIComponent(message)}`;
